import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "plyr/dist/plyr.css"
import "./media_audio_player.css";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
